import { css, keyframes } from '@emotion/react'
import {
  AnimationOptions,
  animationDefaults,
  animation,
} from '../../utils/animation'

const appearAnimationKeyframes = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const disappearAnimationKeyframes = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

const appearAnimation = animation(appearAnimationKeyframes)
const disappearAnimation = animation(disappearAnimationKeyframes)

export interface NotificationAnimation {
  enter?: AnimationOptions
  leave?: AnimationOptions
}

export const getAnimation = ({ enter, leave }: NotificationAnimation) => {
  if (enter && leave) {
    const enterOptions = {
      ...animationDefaults,
      ...enter,
    }

    const leaveOptions = {
      ...animationDefaults,
      ...leave,
    }

    return css`
      animation: ${enterOptions.durationMs}ms ${enterOptions.timingFn}
          ${appearAnimationKeyframes} 0ms ${enterOptions.direction}
          ${enterOptions.fillMode} ${enterOptions.iterationCount}
          ${enterOptions.playState},
        ${leaveOptions.durationMs}ms ${leaveOptions.timingFn}
          ${disappearAnimationKeyframes} ${leaveOptions.delayMs}ms
          ${leaveOptions.direction} ${leaveOptions.fillMode}
          ${leaveOptions.iterationCount} ${leaveOptions.playState};
    `
  }

  if (enter) {
    return appearAnimation(enter)
  }

  if (leave) {
    return disappearAnimation(leave)
  }
}
